/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { PatchSubmissionRubricDataItem } from './PatchSubmissionRubricDataItem';
const PatchSubmissionRubricDataParser = 
/* #__PURE__ */ parsers.object([
    ['items', /* #__PURE__ */ codecArray(PatchSubmissionRubricDataItem)],
]);
export class PatchSubmissionRubricData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchSubmissionRubricDataParser.decode(input).map(res => new PatchSubmissionRubricData(res));
    }
    static unsafeDecode(input) {
        return PatchSubmissionRubricData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchSubmissionRubricDataParser.encode(data);
    }
    static schema() {
        return PatchSubmissionRubricDataParser.schema();
    }
}
